import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useHistory, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  Button,
  Divider,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  IconButton,
  ButtonBase,
} from "@material-ui/core";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";
import {
  InfoWindow,
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon,
  StreetViewPanorama,
} from "react-google-maps";
// chart line
import { Bar } from "react-chartjs-2";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
// swiper
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { propertyDataArray } from "../components/PropertyDataArray";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";
import { Alert } from "@material-ui/lab";
import Map from "../console/components/Map";

const GET_FORECLOSURE = gql`
  query foreclosure($obj_no: Int!) {
    foreclosure(obj_no: $obj_no) {
      obj_no
      obj_court
      obj_str
      obj_share
      obj_caseno
      obj_another
      obj_time
      obj_date_ymd
      obj_date_hi
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_link
      obj_margin
      obj_price
      obj_price_set
      obj_creditor
      obj_debtor
      obj_bulletin_data
      obj_remark
      obj_land_data
      obj_build_data
      obj_land_floor
      obj_build_floor
      obj_add_floor
      obj_s_floor
      obj_c_floor
      obj_total_floor
      obj_transfer
      obj_type
      obj_creat_date
      obj_stop
      obj_tender_num
      obj_tender
      obj_check_num
      obj_stop_link
      obj_source
      obj_marker
      obj_coordinates
      obj_request_num
      obj_cadastral
      obj_patterns
      obj_sql
      obj_pyPDF
      phppdfjoin
      images {
        id
        imageUrl
      }
    }
  }
`;

const GET_EXCLUSIVEPROPERTY = gql`
  query exclusiveProperty($id: Int!) {
    exclusiveProperty(id: $id) {
      id
      obj_court
      obj_str
      obj_share
      obj_caseno
      obj_another
      obj_time
      obj_date_ymd
      hiddenDate
      obj_date_hi
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_link
      obj_margin
      obj_price
      obj_price_set
      obj_creditor
      obj_debtor
      obj_bulletin_data
      obj_remark
      obj_land_data
      obj_build_data
      obj_land_floor
      obj_build_floor
      obj_add_floor
      obj_s_floor
      obj_c_floor
      obj_total_floor
      obj_transfer
      obj_type
      obj_creat_date
      obj_stop
      obj_tender_num
      obj_tender
      obj_check_num
      obj_stop_link
      obj_source
      obj_marker
      obj_coordinates
      obj_request_num
      obj_cadastral
      obj_patterns
      pricePerBuildPing
      pricePerLandPing
      obj_sql
      obj_pyPDF
      phppdfjoin
      errorLog
      lastEditedBy
      images {
        id
        imageUrl
      }
      imageHasCreated
      source
      name
      rent
      deposit
      managementFee
      monthOfManagementFee
      parkingSpace
      houseAge
      indoor_floor
      room
      hall
      bathroom
      orientation
      youtubeUrl
      buildingStructure
      template
      description
      enable
    }
  }
`;

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default function CasePage() {
  const { id } = useParams();
  const Alert = useAlert();
  const [data, setData] = useState();

  const [getForeclosures, { loading }] = useLazyQuery(GET_FORECLOSURE, {
    fetchPolicy: "network-only",
    onCompleted({ foreclosure }) {
      let newData = {};
      for (const key in foreclosure) {
        newData[`${key}`] = foreclosure[key];
      }
      setData(newData);
    },
    notifyOnNetworkStatusChange: true,
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  const [getExclusiveProperty, { loading: exclusivePropertyLoading }] =
    useLazyQuery(GET_EXCLUSIVEPROPERTY, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ exclusiveProperty }) {
        let newData = {};
        for (const key in exclusiveProperty) {
          newData[`${key}`] = exclusiveProperty[key];
        }
        console.log(newData);
        setData(newData);
      },
      onError(error) {
        return Alert.notice(error.message.replace("GraphQL error: ", ""));
      },
    });
  useEffect(() => {
    if (Boolean(id)) {
      if (JSON.parse(localStorage.getItem("@fullhouseFranchise")) === "true") {
        getExclusiveProperty({ variables: { id: Number(id) } });
      } else {
        getForeclosures({ variables: { obj_no: Number(id) } });
      }
    }
  }, [id]);

  return (
    <Box>
      <LoadingModal loading={loading || exclusivePropertyLoading} />
      <CarouselImages data={data} />
      {/* <CarouselBox /> */}
      <CaseDetail data={data} />
      {data && (
        <Map
          height={"400px"}
          direction={"row"}
          sm={6}
          mapData={{
            obj_type: data.obj_type,
            obj_city: data.obj_city,
            obj_area: data.obj_area,
            obj_address: data.obj_address,
            obj_section: data.obj_section,
            obj_section_s: data.obj_section_s,
            obj_landno: data.obj_landno,
          }}
        />
      )}
      {JSON.parse(localStorage.getItem("@fullhouseFranchise")) === "true" &&
        data?.description !== null && (
          <Box>
            <div
              dangerouslySetInnerHTML={{ __html: `${data?.description}` }}
            ></div>
          </Box>
        )}
      {/* <Banner /> */}
      {/* <ChoicePropertyTabs /> */}
    </Box>
  );
}

// Title Component
function Title({ title, data }) {
  const theme = useTheme();
  const Alert = useAlert();
  const history = useHistory();
  const { courtArray } = propertyDataArray();
  return (
    <Box my={3}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item style={{ paddingBottom: "8px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (
                JSON.parse(localStorage.getItem("@fullhouseFranchise")) ===
                "true"
              ) {
                // return Alert.notice("");
              } else {
                history.push("/consultation", {
                  object:
                    courtArray.find((item2) => item2.value === data.obj_court)
                      ?.label ??
                    "" +
                      "(" +
                      data.obj_str +
                      data.obj_share +
                      data.obj_caseno +
                      ")" +
                      `${
                        data.obj_type === "H"
                          ? data.obj_city + data.obj_area + data.obj_address
                          : data.obj_city +
                            data.obj_area +
                            data.obj_section +
                            "段" +
                            data.obj_section_s +
                            (data.obj_section_s ? "小段" : "") +
                            data.obj_landno +
                            (data.obj_landno ? "地號" : "")
                      }`,
                  url: window.location.pathname,
                });
              }
            }}
          >
            我要諮詢
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ backgroundColor: theme.palette.secondary.light }} />
    </Box>
  );
}

//ANCHOR CaseDetail
function CaseDetail({ data }) {
  const history = useHistory();

  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:1280px)");

  const useStyles = makeStyles((theme) => ({
    grid: {
      minHeight: "400px",
    },
    grid2: {
      minHeight: "200px",
    },
    textSecondary: {
      color: theme.palette.grey[700],
    },
    chartBox: {
      marginTop: isTablet ? "60px" : "30px",
      position: "relative",
      "&::before": {
        content: '"萬/坪"',
        position: "absolute",
        top: "-30px",
        left: 0,
        color: theme.palette.success.main,
      },
    },
  }));
  const classes = useStyles();

  function getCourt(value) {
    switch (value) {
      case "TPD":
        return "臺灣臺北地方法院";
      case "PCD":
        return "臺灣新北地方法院";
      case "SLD":
        return "臺灣士林地方法院";
      case "TYD":
        return "臺灣桃園地方法院";
      case "SCD":
        return "臺灣新竹地方法院";
      case "MLD":
        return "臺灣苗栗地方法院";
      case "TCD":
        return "臺灣臺中地方法院";
      case "NTD":
        return "臺灣南投地方法院";
      case "CHD":
        return "臺灣彰化地方法院";
      case "ULD":
        return "臺灣雲林地方法院";
      case "CYD":
        return "臺灣嘉義地方法院";
      case "TND":
        return "臺灣臺南地方法院";
      case "CTD":
        return "臺灣橋頭地方法院";
      case "KSD":
        return "臺灣高雄地方法院";
      case "PTD":
        return "臺灣屏東地方法院";
      case "TTD":
        return "臺灣臺東地方法院";
      case "HLD":
        return "臺灣花蓮地方法院";
      case "ILD":
        return "臺灣宜蘭地方法院";
      case "KLD":
        return "臺灣基隆地方法院";
      case "PHD":
        return "臺灣澎湖地方法院";
      case "KMD":
        return "福建金門地方法院";
      case "LCD":
        return "福建連江地方法院";
      default:
        break;
    }
  }
  function getPatterns(value) {
    if (!!data) {
      switch (value) {
        case "L":
          return data.obj_patterns ? data.obj_patterns : "土地";
        case "H":
          return data.obj_patterns;
        default:
          break;
      }
    }
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another)
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another);
  }

  if (!!data) {
    return (
      <Box py={4}>
        <Container maxWidth="xl">
          <Box p={isPhone ? 0 : 3}>
            {/* 區域、行情 */}
            <Grid container justifyContent="center" spacing={1}>
              {/* 區域 */}
              <Grid
                item
                container
                justifyContent="center"
                xs={12}
                lg={8}
                className={classes.grid}
              >
                <Grid item xs={12}>
                  <Title title={data.obj_city + data.obj_area} data={data} />
                </Grid>

                {/* 總價 */}

                <Grid item xs={12} md={6} lg={4} className={classes.grid2}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    底價&ensp;:&ensp;
                    {!!data.obj_price ? data.obj_price.toFixed(2) : 0}萬
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    保證金&ensp;:&ensp;
                    {!!data.obj_margin
                      ? (data.obj_margin / 10000).toFixed(2)
                      : 0}
                    萬
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    拍次&ensp;:&ensp;
                    <Typography
                      style={{
                        color: theme.palette.secondary.light,
                        fontWeight: "bold",
                      }}
                      variant="h6"
                      component="span"
                    >
                      {data.obj_time}
                    </Typography>
                  </Typography>
                </Grid>
                {/* divider */}
                <Grid
                  item
                  container
                  justifyContent="center"
                  xs={1}
                  style={{ display: isTablet ? "none" : "" }}
                >
                  <Divider
                    orientation="vertical"
                    style={{
                      backgroundColor: theme.palette.secondary.light,
                      minHeight: "200px",
                    }}
                  />
                </Grid>
                {/* info */}
                <Grid
                  item
                  container
                  alignItems="center"
                  xs={12}
                  lg={7}
                  md={5}
                  className={classes.grid2}
                >
                  {/* left part */}
                  <Grid item xs={12} sm={4}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      類型&ensp;:&ensp;{getPatterns(data.obj_type)}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      總建坪&ensp;:&ensp;
                      {data.obj_type === "L"
                        ? 0
                        : !!data.obj_total_floor
                        ? data.obj_total_floor.toFixed(2)
                        : 0}
                      坪
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      地坪&ensp;:&ensp;
                      {!!data.obj_land_floor
                        ? data.obj_land_floor.toFixed(2)
                        : 0}
                      坪
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      增建坪&ensp;:&ensp;
                      {!!data.obj_add_floor ? data.obj_add_floor.toFixed(2) : 0}
                      坪
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      附建坪&ensp;:&ensp;
                      {!!data.obj_s_floor ? data.obj_s_floor.toFixed(2) : 0}坪
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      建坪&ensp;:&ensp;
                      {!!data.obj_build_floor
                        ? data.obj_build_floor.toFixed(2)
                        : 0}
                      坪
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      公設坪&ensp;:&ensp;
                      {!!data.obj_c_floor ? data.obj_c_floor.toFixed(2) : 0}坪
                    </Typography>
                  </Grid>
                  {/* right part */}
                  <Grid item xs={12} lg={8}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      地址&ensp;:&ensp;
                      {data.obj_type === "H"
                        ? data.obj_city + data.obj_area + data.obj_address
                        : data.obj_city +
                          data.obj_area +
                          data.obj_section +
                          "段" +
                          data.obj_section_s +
                          (data.obj_section_s ? "小段" : "") +
                          data.obj_landno +
                          (data.obj_landno ? "地號" : "")}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      拍賣法院&ensp;:&ensp;
                      {getCourt(data.obj_court)}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      案號&ensp;:&ensp;
                      {getCaseName(
                        data.obj_str,
                        data.obj_share,
                        data.obj_caseno,
                        data.obj_another
                      )}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      拍賣日期&ensp;:&ensp;
                      {moment(data.obj_date_ymd).format("YYYY/MM/DD")}
                    </Typography>
                    {/* <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      格局&ensp;:&ensp;
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="body1"
                      className={classes.textSecondary}
                    >
                      停車位&ensp;:&ensp;
                    </Typography> */}
                  </Grid>
                </Grid>
                {localStorage
                  .getItem("@fullhouse-searchType")
                  .includes("detail") && (
                  <>
                    <Grid item container>
                      <Divider
                        style={{
                          marginTop: "20px",
                          marginBottom: "20px",
                          minWidth: "100%",
                          backgroundColor: theme.palette.secondary.light,
                        }}
                      />
                    </Grid>
                    <Grid item container xs={12} lg={12} md={12}>
                      <Grid item>
                        <Typography
                          gutterBottom
                          variant="body1"
                          className={classes.textSecondary}
                        >
                          公告筆錄&ensp;:&ensp;
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="body1"
                          style={{ whiteSpace: "break-spaces" }}
                        >
                          {data.obj_bulletin_data.replace(/<br>/g, "\n")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
              {/* 行情 */}
              {/* <Grid item container xs={12} lg={4} className={classes.grid}>
                <Grid item xs={12}>
                  <Title title="社區行情" />
                </Grid>
                <Grid item xs={12} lg={5} md={6}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ color: theme.palette.secondary.light }}
                  >
                    {caseInfo.communityName}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    最新成交&ensp;:&ensp;坪
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    價格區間&ensp;:&ensp;萬/坪
                  </Typography>

                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    社區年齡&ensp;:&ensp;年
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    實價登入&ensp;:&ensp;萬
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    在刊物件&ensp;:&ensp;
                    <Typography
                      component="span"
                      style={{ color: theme.palette.secondary.light }}
                    >
                      {caseInfo.onPublish}筆法拍屋
                    </Typography>
                  </Typography>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  item
                  xs={12}
                  lg={7}
                  md={6}
                  style={{ marginTop: isPhone ? "2em" : "" }}
                >
                  <Grid item xs={12}>
                    <Typography
                      align="center"
                      className={classes.textSecondary}
                      variant="body1"
                    >
                      近一年參考平均價
                      <Typography
                        style={{ color: theme.palette.secondary.light }}
                        component="span"
                      >
                        {caseInfo.recentPricePerPing}萬/坪
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box my={2} className={classes.chartBox}>
                      <Bar
                        data={chartData}
                        width={isTablet ? 430 : 200}
                        height={isTablet ? 430 : 200}
                        options={{
                          plugins: {
                            legend: {
                              display: false,
                            },
                          },
                        }}
                        style={{
                          width: isTablet ? (isPhone ? 300 : 450) : 230,
                          height: isTablet ? (isPhone ? 300 : 450) : 230,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid> */}
            </Grid>
            {/* 試算、地圖 */}
            <Grid container spacing={isPhone ? 1 : 4}>
              {/* ANCHOR 試算*/}
              {/* <Grid item container xs={12} lg={5} className={classes.grid}>
                <Grid item xs={12}>
                  <Title title="房貸試算" />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    className={classes.textSecondary}
                  >
                    單價 &ensp;:&ensp; {caseInfo.pricePerPing}萬/坪
                  </Typography>
                  <Typography
                    gutterBottom
                    className={classes.textSecondary}
                    variant="body1"
                  >
                    參考月付 &ensp;:&ensp;
                    <Typography
                      style={{ color: theme.palette.secondary.light }}
                      component="span"
                    >
                      {caseInfo.pricePerMonth}元
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item container xs={12} sm={6}>
                  <Button
                    size="large"
                    color="primary"
                    fullWidth
                    variant="contained"
                    style={{ borderRadius: "50px" }}
                    onClick={() => history.push("./interest-calculation")}
                  >
                    房貸試算工具
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    size="large"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    style={{ borderRadius: "50px" }}
                  >
                    我要諮詢
                  </Button>
                </Grid>
              </Grid> */}
              {/* 地圖 */}
              {/* <Grid
                item
                container
                alignItems="center"
                xs={12}
                lg={7}
                className={classes.grid}
                spacing={2}
              >
                <Grid item container justifyContent="center" xs={12} lg={6}>
                  <img
                    src="/assets/images/home/choiceProperty.png"
                    style={{
                      width: isTablet ? "300px" : "100%",
                      objeftFit: "cover",
                      height: isTablet ? "auto" : "300px",
                    }}
                  />
                </Grid>
                <Grid item container justifyContent="center" xs={12} lg={6}>
                  <img
                    src="/assets/images/home/choiceProperty.png"
                    style={{
                      width: isTablet ? "300px" : "100%",
                      objeftFit: "cover",
                      height: isTablet ? "auto" : "300px",
                    }}
                  />
                </Grid>
              </Grid> */}
            </Grid>
          </Box>
        </Container>
      </Box>
    );
  } else {
    return null;
  }
}

//ANCHOR Banner
function Banner() {
  const useStyles = makeStyles((theme) => ({
    bannerBox: {
      position: "relative",
    },
    textBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.bannerBox}>
      <img
        src={"/assets/images/Home/findBestPlace.png"}
        style={{ height: "400px", width: "100%", objectFit: "cover" }}
      />
      <Container maxWidth="lg">
        <Box className={classes.textBox}>
          <Typography align="center" variant="h5" style={{ color: "#fff" }}>
            FULLHOUSE FORECLOSURE
          </Typography>
          <Typography align="center" variant="h6" style={{ color: "#fff" }}>
            熱門推薦
          </Typography>
        </Box>
      </Container>
    </div>
  );
}

// ANCHOR tabs  (ChoicePropertyTabs)
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

// ANCHOR 輪播
function CarouselImages({ data }) {
  const [imageIndex, setImageIndex] = useState(0);
  const isTablet = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    arrowBtn: {
      color: "grey",
      transition: "all 1s",
      "&:hover": {
        color: "#fff",
      },
    },
  }));
  const classes = useStyles();

  // 輪播圖
  function _arrowNext() {
    if (imageIndex < images.length - 1) {
      setImageIndex(imageIndex + 1);
    } else if (imageIndex === images.length - 1) {
      setImageIndex(0);
    }
  }

  function _arrowPrev() {
    if (imageIndex > 0) {
      setImageIndex(imageIndex - 1);
    } else if (imageIndex === 0) {
      setImageIndex(images.length - 1);
    }
  }
  const [images, setImages] = useState([]);
  useEffect(() => {
    setImages([]);
    if (data?.images.length > 0) {
      let newImages = [];
      data?.images.forEach((item) => {
        newImages.push(item.imageUrl);
      });
      setImages(newImages);
    } else {
      setImages([
        data?.obj_type === "L"
          ? "/assets/images/Home/land.jpg"
          : "/assets/images/Home/choiceProperty.jpg",
      ]);
    }
  }, [data]);
  return (
    <Box mt={15}>
      <Container maxWidth="md">
        <Carousel
          autoPlay
          showThumbs={false}
          infiniteLoop={true}
          emulateTouch={true}
          showArrows={false}
          selectedItem={imageIndex}
          onChange={setImageIndex}
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            textAlign: isTablet ? "center" : "",
            position: "relative",
          }}
        >
          {images.map((item, index) => (
            <>
              {/* Prev箭頭 */}
              <Box
                position="absolute"
                zIndex="2"
                left={10}
                style={{ top: "50%", transform: "translateY(-50%)" }}
              >
                <Button onClick={_arrowPrev}>
                  <ArrowBackIcon className={classes.arrowBtn} />
                </Button>
              </Box>
              {/* Next箭頭 */}
              <Box
                position="absolute"
                zIndex="2"
                right={10}
                style={{ top: "50%", transform: "translateY(-50%)" }}
              >
                <Button onClick={_arrowNext}>
                  <ArrowForwardIcon className={classes.arrowBtn} />
                </Button>
              </Box>
              <img
                src={item}
                key={index}
                style={{
                  // 如果要完整顯示改成contain
                  objectFit: "cover",
                  width: "100%",
                  height: isPhone ? "300px" : isTablet ? "550px" : "600px",
                  borderRadius: "10px",
                  padding: "5px",
                }}
              />
            </>
          ))}
        </Carousel>
        <Box padding={1} mx="auto">
          <Grid
            container
            spacing={1}
            wrap="nowrap"
            style={{ overflowX: "scroll" }}
          >
            {images.map((item, index) => (
              <Grid item>
                <ButtonBase
                  onClick={() => setImageIndex(index)}
                  style={{
                    width: isPhone ? "60px" : "80px",
                    height: isPhone ? "60px" : "80px",
                  }}
                >
                  <img
                    src={item}
                    key={index}
                    style={{
                      border: imageIndex === index ? "1px solid" : "0px solid",
                      borderRadius: "3px",
                      width: "inherit",
                      height: "inherit",
                      objectFit: "cover",
                    }}
                  />
                </ButtonBase>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
